<div
  class="learning-plan-setup-panel flex max-h-[90vh] flex-col overflow-hidden"
>
  <div class="flex shrink-0 items-center gap-4 px-6 pt-6">
    @if (!data.isCustomTraining) {
      <app-step-indicator
        [totalSteps]="steps.length"
        [currentStep]="selectedIndex"
      ></app-step-indicator>
    }
    <span class="grow text-xl font-semibold">
      {{
        'portal.trainings.setup.' + steps[selectedIndex].key + '.title'
          | transloco
      }}
    </span>
    @if (selectedIndex !== 0) {
      <div class="flex items-center gap-1 text-sm">
        <span class="font-light text-grey">
          {{ 'portal.trainings.setup.training' | transloco }}:
        </span>
        <span class="text-dark-blue font-normal">
          {{ dataService.formGroupSettings.get('learningPlanName')?.value }}
        </span>
      </div>
    }
  </div>
  <div class="flex min-h-0 grow flex-col gap-6 overflow-y-auto p-6">
    @if (steps[selectedIndex]) {
      @switch (steps[selectedIndex].key) {
        @case ('configuration') {
          <app-learning-plan-setup-configuration
            [isCustomTraining]="data.isCustomTraining"
            [isPrecuratedTraining]="isPreCuratedTraining"
          >
          </app-learning-plan-setup-configuration>
        }
        @case ('enrollment') {
          <app-learning-plan-setup-enrollment
            class="h-full"
            (canEnrollChanged)="canEnroll = $event"
            (addLicensesButtonClickEvent)="onAddLicensesButtonClick()"
          >
          </app-learning-plan-setup-enrollment>
        }
      }
    }
    @if (selectedIndex === 0 && !data.isCustomTraining) {
      <div
        animate.enter="fade-in"
        animate.leave="fade-out"
        tabindex="0"
        class="flex flex-col rounded-xl border border-grey-lightGrey p-5"
        [ngClass]="{
          'cursor-pointer': !showOtherOptions && !isAdvancedOptionsLocked,
          'cursor-not-allowed': isAdvancedOptionsLocked,
        }"
        (click)="onOpenOtherOptionsClick()"
        (keydown.enter)="onOpenOtherOptionsClick()"
      >
        <div
          class="flex items-center justify-between gap-2"
          [ngClass]="{ 'cursor-pointer': !isAdvancedOptionsLocked }"
          tabindex="0"
          (click)="toggleOtherOptions($event)"
          (keydown.enter)="toggleOtherOptions($event)"
        >
          <div class="flex gap-1">
            <span
              class="text-base font-light text-grey"
              [class.opacity-40]="isAdvancedOptionsLocked"
            >
              {{ 'portal.trainings.setup.advancedOptions' | transloco }}
            </span>
            @if (!isAdvancedOptionsLocked) {
              <mat-icon
                class="hvs-icon text-grey-midGrey"
                [matTooltip]="
                  'portal.trainings.setup.advancedOptionsTooltip' | transloco
                "
                matTooltipPosition="above"
                matTooltipClass="tooltip-above"
              >
                help_outline
              </mat-icon>
            }
          </div>
          @if (isAdvancedOptionsLocked) {
            <mat-icon
              class="hvs-icon material-icons-outlined"
              [matTooltip]="
                'portal.trainings.setup.advancedOptionsLockedTooltip'
                  | transloco
              "
              matTooltipPosition="above"
              matTooltipClass="tooltip-above"
            >
              lock
            </mat-icon>
          } @else {
            <mat-icon
              class="hvs-icon-xl text-blue"
              [ngClass]="{ 'rotate-180': showOtherOptions }"
            >
              keyboard_arrow_down
            </mat-icon>
          }
        </div>
        <div
          class="other-options-expandable-wrapper"
          [ngClass]="{ open: showOtherOptions && !isAdvancedOptionsLocked }"
        >
          <div class="flex flex-col gap-5 overflow-hidden">
            @if (!isPrecuratedLearningPlansLoading()) {
              <div
                class="mt-5 flex items-start justify-between rounded-xl bg-grey-veryLightGrey p-5"
              >
                <div class="flex flex-col gap-2">
                  <div class="flex items-center gap-2">
                    <mat-icon
                      class="hvs-icon material-icons-outlined text-blue"
                    >
                      dashboard_customize
                    </mat-icon>
                    <span class="text-base font-semibold text-blue-dark">
                      {{
                        'portal.trainings.setup.customTraining.title'
                          | transloco
                      }}
                    </span>
                  </div>
                  <span class="text-sm font-light text-grey">
                    {{
                      'portal.trainings.setup.customTraining.description'
                        | transloco
                    }}
                  </span>
                </div>
                <app-text-button (click)="onCustomTrainingClick()">
                  <div class="flex items-center">
                    <span>
                      {{
                        'portal.trainings.setup.customTraining.button'
                          | transloco
                      }}
                    </span>
                    <mat-icon class="hvs-icon text-blue">
                      keyboard_arrow_right
                    </mat-icon>
                  </div>
                </app-text-button>
              </div>
              @if (hasPrecuratedLearningPlan) {
                <div
                  class="flex flex-col gap-6 rounded-xl bg-grey-veryLightGrey p-5"
                >
                  <div class="flex items-start justify-between">
                    <div class="flex flex-col gap-2">
                      <div class="flex items-center gap-2">
                        <mat-icon
                          fontSet="material-symbols-outlined"
                          class="hvs-icon material-icons-outlined text-blue"
                        >
                          conversion_path
                        </mat-icon>

                        <span class="text-base font-semibold text-blue-dark">
                          {{
                            'portal.trainings.setup.predefinedTraining.title'
                              | transloco
                          }}
                        </span>
                      </div>

                      <span class="text-sm font-light text-grey">
                        {{
                          'portal.trainings.setup.predefinedTraining.description'
                            | transloco
                              : {
                                  phaseNumber: getPhaseNumber(
                                    currentPhase()?.name
                                  ),
                                  trainingName:
                                    'portal.trainings.precuratedLearningPlanCard.' +
                                      this.precuratedLearningPlan()?.name +
                                      '.name' | transloco,
                                }
                        }}
                      </span>
                    </div>

                    <app-text-button (click)="onPrecuratedClick()">
                      <div class="flex items-center">
                        <span>
                          {{
                            'portal.trainings.setup.predefinedTraining.button'
                              | transloco
                          }}
                        </span>

                        <mat-icon class="hvs-icon text-blue">
                          keyboard_arrow_right
                        </mat-icon>
                      </div>
                    </app-text-button>
                  </div>

                  <div
                    class="mx-auto flex justify-center rounded-lg border border-gray-300 bg-white p-6"
                  >
                    <div class="flex items-center gap-6 overflow-x-auto">
                      @for (phase of phases(); track phase; let i = $index) {
                        <div
                          class="flex items-center gap-2 rounded-md border border-gray-300 bg-white px-4 py-3"
                          tabindex="0"
                          [ngClass]="{
                            'border-blue-500 shadow-md':
                              phase === currentPhase(),
                            'border-gray-300': phase !== currentPhase(),
                          }"
                        >
                          <mat-icon
                            class="material-icons-outlined text-blue-dark"
                            [svgIcon]="getCourseIcon(phase.course.name)"
                          ></mat-icon>

                          <span
                            class="break-words text-sm font-semibold leading-tight text-primary"
                          >
                            {{
                              'portal.courses.courseTitleKeys.' +
                                phase.course.name +
                                '.name' | transloco
                            }}
                          </span>
                        </div>

                        @if (i < phases().length - 1) {
                          <mat-icon class="material-icons text-gray-400">
                            arrow_forward
                          </mat-icon>
                        }
                      }
                    </div>
                  </div>
                </div>
              }
            } @else {
              <div class="flex size-full items-center justify-center">
                <app-loading class="size-12"></app-loading>
              </div>
            }
          </div>
        </div>
      </div>
    }
  </div>
  <div class="border-grey-light flex shrink-0 flex-col gap-4 border-t p-6">
    @if (showNextButton) {
      <app-primary-button
        (click)="onNextClick()"
        [text]="'portal.trainings.setup.next' | transloco"
      >
      </app-primary-button>
    }
    @if (!showNextButton) {
      <app-primary-button
        [loading]="dataService.isLoading"
        [disabled]="dataService.selectedStudents.length > 0 && !canEnroll"
        (click)="onSubmitClick()"
        [text]="
          (dataService.selectedStudents.length === 0
            ? 'portal.trainings.setup.saveOnly'
            : 'portal.trainings.setup.saveAndInviteParticipants'
          ) | transloco
        "
      >
      </app-primary-button>
    }

    <app-text-button class="self-center text-base" (click)="onPreviousClick()">
      {{
        (data.isCustomTraining && selectedIndex === 0
          ? 'portal.trainings.setup.cancel'
          : 'portal.trainings.setup.back'
        ) | transloco
      }}
    </app-text-button>
  </div>
</div>
